import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import * as yup from 'yup';

export const useYupSchema = () => {
  const translate = useTypedTranslate();

  return yup.object().shape({
    roles: yup
      .array()
      .of(yup.string().required())
      .min(1, translate('app.validation.required'))
      .required(translate('app.validation.required')),

    users: yup
      .array()
      .of(yup.string().required())
      .min(1, translate('app.validation.required'))
      .required(translate('app.validation.required')),
  });
};
